import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../../utils/axios';
import Layout from '../../components/user/Layout';
import { PAYMENT_WALLET_ROUTE } from '../../routes/web/rootRoutes';

function PaymentCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyPayment = async () => {
      const params = new URLSearchParams(location.search);
      const transactionId = params.get('transaction_id');

      if (!transactionId) {
        setStatus('error');
        setMessage('No transaction ID found.');
        return;
      }

      try {
        const response = await axios.get('payment/status', {
          params: { transaction_id: transactionId }
        });

        if (response.data.success) {
          const paymentStatus = response.data.data.status;
          if (paymentStatus === 'completed') {
            setStatus('success');
            setMessage('Payment completed successfully!');
            setTimeout(() => navigate(PAYMENT_WALLET_ROUTE), 3000);
          } else if (paymentStatus === 'failed') {
            setStatus('error');
            setMessage('Payment failed. Please try again.');
          } else {
            setStatus('pending');
            setMessage(`Payment status: ${paymentStatus}. Please check back later.`);
          }
        } else {
          setStatus('error');
          setMessage(response.data.message || 'Verification failed.');
        }
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.message || 'An error occurred during verification.');
      }
    };

    verifyPayment();
  }, [location, navigate]);

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full text-center">
          {status === 'verifying' && (
            <>
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
              <p className="mt-4 text-gray-600">Verifying your payment...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div className="text-green-500 text-5xl mb-4">✓</div>
              <h2 className="text-2xl font-bold text-green-600 mb-2">Success!</h2>
              <p className="text-gray-600">{message}</p>
              <p className="text-sm text-gray-500 mt-4">Redirecting to wallet...</p>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="text-red-500 text-5xl mb-4">✗</div>
              <h2 className="text-2xl font-bold text-red-600 mb-2">Payment Failed</h2>
              <p className="text-gray-600">{message}</p>
              <button
                onClick={() => navigate('/payment-wallet')}
                className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
              >
                Return to Wallet
              </button>
            </>
          )}
          {status === 'pending' && (
            <>
              <div className="text-yellow-500 text-5xl mb-4">⏳</div>
              <h2 className="text-2xl font-bold text-yellow-600 mb-2">Pending</h2>
              <p className="text-gray-600">{message}</p>
              <button
                onClick={() => navigate('/payment-wallet')}
                className="mt-6 bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700"
              >
                Go to Wallet
              </button>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
}

export default PaymentCallback;